// MF-566 — Card 'learning-support': the "Learning Support" block of the Belmont dashboard — the student's
// current adjustment (category, last and next review) and the adjustments provided, as chips. One student;
// the server only answers staff, and with the student chosen (a disability record, never school-wide).
import { Box, Typography } from '@mui/material'
import { SUMMARY_PALETTE } from '../../../Dashboard/StudentSummary/summary.palette'

const CHIP = { bgcolor: '#fdf3cf', color: '#7a5b00' }

const Line = ({ label, children, color }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      gap: 2,
      py: 1,
      borderBottom: `1px solid ${SUMMARY_PALETTE.grid}`
    }}
  >
    <Typography sx={{ fontSize: 11, color: SUMMARY_PALETTE.ink }}>{label}</Typography>
    <Typography
      sx={{
        fontSize: 14,
        fontWeight: color ? 500 : 700,
        color: color || SUMMARY_PALETTE.ink,
        textAlign: 'right'
      }}
    >
      {children || '–'}
    </Typography>
  </Box>
)

const LearningSupportCard = ({ data }) => {
  const r = data?.rows?.[0]
  if (!r) return null
  const adjustments = String(r.adjustments || '')
    .split(';')
    .map((x) => x.trim())
    .filter(Boolean)
  return (
    <Box sx={{ height: '100%', overflowY: 'auto', minHeight: 0 }}>
      <Typography sx={{ fontSize: 13, color: SUMMARY_PALETTE.muted, mb: 0.5 }}>Current Adjustment</Typography>
      <Line label='Category'>{r.category}</Line>
      <Line label='Last Reviewed' color={SUMMARY_PALETTE.good}>
        {r.last_reviewed}
      </Line>
      <Line label='Next Review' color='#a4492d'>
        {r.next_review}
      </Line>
      <Typography sx={{ fontSize: 13, color: SUMMARY_PALETTE.muted, mt: 3, mb: 1 }}>
        Adjustments Provided
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {adjustments.map((a) => (
          <Box key={a} sx={{ ...CHIP, px: 1.5, py: 0.25, borderRadius: '12px', fontSize: 12 }}>
            {a}
          </Box>
        ))}
        {adjustments.length === 0 ? (
          <Typography sx={{ fontSize: 12, color: SUMMARY_PALETTE.faint }}>–</Typography>
        ) : null}
      </Box>
    </Box>
  )
}

export default LearningSupportCard
